<div style="width: 160px;" class="range-text">
  <label style="font-weight: bold; white-space: nowrap;"> {{ filterBase.label}}</label><br>
  <div class="row">
    <div class="col" style="margin: 0; padding: 0;" ><input (change)="setValue('from',$event)"  style="width:90px;" class="text-field" type="number"></div>
    <div class="col " style="margin: 0; padding: 0;"><input (change)="setValue('to',$event)" style="width: 90px;" class="text-field" type="number"></div>
  </div>
</div>
